export const fontFamily = {
    interNormal: "'Inter', sans-serif"
};
